module.exports = __webpack_public_path__ + "static/media/patient-ico-grey.3b32faf2.svg";